import type { OldPurchaseHistoryEntry } from '../iap/types';
import { IAPProductId, OfferType } from '../iap/types';
import type { OfferSystemData } from '../../libs/offerSystem/OfferSystemHistory';

const defaultEntry = {
  activation: { current: null, lastDeactivation: null, activationNumber: 0 },
  purchased: [],
};

export function migrateOfferData(purchaseHistory: OldPurchaseHistoryEntry[]): OfferSystemData {
  const result: OfferSystemData = {};

  purchaseHistory.forEach((entry) => {
    let productId: string = entry.offerType;
    let lastDeactivation: number | null = null;
    if (entry.offerType === OfferType.CoinPack) {
      productId = IAPProductId.CoinPack01;
    } else if (entry.offerType === OfferType.StarterOffer) {
      productId = IAPProductId.StarterOffer01;
      lastDeactivation = entry.purchaseDate;
    } else if (entry.offerType === OfferType.UpsellBundle) {
      productId = IAPProductId.UpsellBundle;
      lastDeactivation = entry.purchaseDate;
    }

    if (!result[productId]) {
      result[productId] = { ...defaultEntry };
    }

    if (lastDeactivation) {
      result[productId].activation.lastDeactivation = lastDeactivation;
      result[productId].activation.activationNumber += 1;
    }

    result[productId].purchased.push({
      activationId: 'unknown',
      date: entry.purchaseDate,
      offerId: productId,
      usdCentPrice: entry.usdCentPrice,
    });
  });

  return result;
}
